
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class KochSnowflakeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (400 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size);
        const scale = config.parallaxScale || 1.0;
        const iterations = Math.floor(3 * (config.parallaxComplexity || 1.0));

        ctx.strokeStyle = pc.color;

        const drawKochLine = (x1: number, y1: number, x2: number, y2: number, level: number) => {
            if (level === 0) {
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                return;
            }

            const dx = x2 - x1;
            const dy = y2 - y1;

            const p1 = { x: x1 + dx / 3, y: y1 + dy / 3 };
            const p3 = { x: x1 + 2 * dx / 3, y: y1 + 2 * dy / 3 };

            const h = Math.sqrt(3) / 6;
            const pm = {
                x: (x1 + x2) / 2 - h * dy,
                y: (y1 + y2) / 2 + h * dx
            };

            drawKochLine(x1, y1, p1.x, p1.y, level - 1);
            drawKochLine(p1.x, p1.y, pm.x, pm.y, level - 1);
            drawKochLine(pm.x, pm.y, p3.x, p3.y, level - 1);
            drawKochLine(p3.x, p3.y, x2, y2, level - 1);
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += size) {
                for (let y = y1; y <= y2; y += size) {
                    const s = size * 0.5 * scale;
                    ctx.beginPath();
                    const p1 = { x: x, y: y - s };
                    const p2 = { x: x + s * Math.cos(Math.PI/6), y: y + s * Math.sin(Math.PI/6) };
                    const p3 = { x: x - s * Math.cos(Math.PI/6), y: y + s * Math.sin(Math.PI/6) };
                    
                    drawKochLine(p1.x, p1.y, p2.x, p2.y, iterations);
                    drawKochLine(p2.x, p2.y, p3.x, p3.y, iterations);
                    drawKochLine(p3.x, p3.y, p1.x, p1.y, iterations);
                    ctx.stroke();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
